import React from 'react';
import PropTypes from 'prop-types';
import { Box, ListItem } from '@mui/material';

import BusinessIcon from '../../../images/icons/business.svg';

const OrgGroup = ({ item, index, style }) => {
  return (
    <div key={index} style={style}>
      <ListItem>
        <Box display="flex" alignItems="center" gap="12px">
          <img src={BusinessIcon} />
          {item.group}
        </Box>
      </ListItem>
    </div>
  );
};

OrgGroup.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number,
  style: PropTypes.object,
};

export default OrgGroup;
